<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Employee User Accounts</h4>
    <hr />
    <div class="row">
      <div class="col">
        <div style="margin: 0 auto; width: 10px;" v-if="isFetching">
          <div class="loader-dark-blue medium mb-5 mt-5"></div>
        </div>
        <div class="mb-3" v-if="!isFetching">
          <span v-show="userAccounts.length">Number of data found: <b-badge pill variant="primary">{{userAccounts.length}}</b-badge></span>
          <b-btn class="float-right" variant="primary" size="sm" @click="add()" v-show="!isFetching"><i class="fa fa-plus"></i> Add</b-btn>
        </div>
        <b-alert variant="danger"
          class="text-center"
          :show="!isFetching && !userAccounts.length">
          Data is empty
        </b-alert>
        <b-table responsive hover striped :fields="fields" :items="userAccounts" :per-page="itemsPerPage" :current-page="currentPage" v-show="!isFetching && userAccounts.length">
          <template v-slot:cell(SERVICE)="row">
            <li v-for="service in row.item.USER_SERVICE_CODE" :key="service.SERVICE_CODE">
              {{ getUserServiceName(service.SERVICE_CODE) }}
            </li>
          </template>
          <template v-slot:cell(MODULE-ROLE)="row">
            <ul class="pl-3">
              <li v-for="(module, idx) in getUserModule(row.item.USER_SERVICE_CODE)" :key="idx">
                {{module.MODULE_NAME}} ({{ module.USER_ROLE_NAME }})
              </li>
            </ul>
          </template>
          <template v-slot:cell(STATUS)="row">
            <span class="badge badge-sm" v-bind:class="{'badge-success': row.value, 'badge-danger': !row.value}">{{row.value ? 'ACTIVE' : 'INACTIVE'}}</span>
          </template>
          <template v-slot:cell(ACTIONS)="row">
            <b-btn variant="warning" size="sm" @click="edit(row.item)" v-b-tooltip.hover title="Edit account">
              <i class="fa fa-pencil-square-o"></i>
            </b-btn>
            <b-btn class="ml-2" variant="info" size="sm" @click="viewProfile(row.item)" v-b-tooltip.hover title="View profile">
              <i class="fa fa-eye"></i>
            </b-btn>
            <b-btn v-show="row.item.STATUS < 1" class="ml-2" variant="success" size="sm" @click="activateAccount(row.item)" v-b-tooltip.hover title="Activate account">
              <i class="fa fa-check"></i>
            </b-btn>
          </template>
        </b-table>
        <b-pagination v-show="userAccounts.length > 10" :total-rows="userAccounts.length" :per-page="itemsPerPage" v-model="currentPage" />
      </div>
    </div>
  </div>
</template>
<script>
import { server, fieldsService } from '@/services/'
import { UserAccountsModal, UserProfilesModal, ActivateAccountModal } from '@/components/modals/'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  name: 'user-accounts',
  data () {
    return {
      errorMsg: Object,
      itemsPerPage: 10,
      currentPage: 1,
      itemsCount: 0,
      fields: fieldsService.USER_ACCOUNTS
    }
  },
  methods: {
    loadUserAccounts () {
      this.isFetching = true
      server.get('/getUA').then(
        (resp) => {
          this.isFetching = false
          this.items = resp.data.msgContent.data
          this.itemsCount = resp.data.msgContent.count
        },
        (err) => {
          this.error = err.response
        }
      )
    },
    getUserModule (userService) {
      return userService
        .map(obj => obj.USER_MODULE)
        .reduce((arr, details) => arr.concat(details.map(o => o)), [])
    },
    add () {
      this.$modal.show(UserAccountsModal, {mode: 'Add'}, {height: 'auto', scrollable: true})
    },
    edit (obj) {
      this.$modal.show(UserAccountsModal, {mode: 'Edit', model: obj}, {height: 'auto', scrollable: true})
    },
    viewProfile (obj) {
      this.$modal.show(UserProfilesModal, {model: obj, caller: 'userAccount'}, {height: 'auto'})
    },
    activateAccount(account) {
      this.$modal.show(ActivateAccountModal, {model: account}, {height: 'auto', scrollable: true})
    }
  },
  created () {
    this.$store.commit('userAccount/setIsFetching', true)
    Promise.all([
      this.$store.cache.dispatch('userService/getAll'),
      this.$store.cache.dispatch('userProfile/getAll'),
      this.$store.cache.dispatch('userRole/getAll'),
      this.$store.cache.dispatch('userAccount/getAllEmployee')
    ]).then(
      resp => {
        this.$store.commit('userAccount/setIsFetching', false)
      }
    )
  },
  computed: {
    ...mapState('userAccount', {
      userAccounts: state => state.items,
      isFetching: state => state.isFetching
    }),
    ...mapState('userService', {
      userServices: state => state.items
    }),
    ...mapState('userProfile', {
      userProfiles: state => state.items
    }),
    ...mapState('userRole', {
      userRoles: state => state.items
    }),
    ...mapGetters('userService', [
      'getUserServiceName'
    ]),
    ...mapGetters('userRole', [
      'getRoleName'
    ])
  }
}
</script>
